import { useI18n } from "react-simple-i18n";
import { styled } from "@mui/material/styles";
import { Stack, Typography } from "@mui/material";

import { GlobalSpacing } from "./styles";
import { menuItems } from "./header.config";
import { useCustomNavigate } from "../../provider/navigate";

const SubHeader = () => {
	const { t } = useI18n();
	const { customNavigate } = useCustomNavigate();

	return (
		<SubHeaderWrapper>
			<MenuSection>
				{menuItems.map((item: MenuItemData, key: number) => (
					<MenuItem onClick={customNavigate(item.link)} key={key}>
						<Typography variant="body1">{t(`header.${item.label}`)}</Typography>
					</MenuItem>
				))}
			</MenuSection>
		</SubHeaderWrapper>
	)
}

const SubHeaderWrapper = styled(GlobalSpacing)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	background: theme.palette.common.subHeaderBg,
	height: 45,

	[theme.breakpoints.down("md")]: {
		display: "none",
	}
}))

const MenuSection = styled(Stack)(({ theme }) => ({
	flex: 1,
	display: "flex",
	flexDirection: "row",
	gap: theme.spacing(3),
	flexWrap: "wrap",
}))

const MenuItem = styled(Stack)<{ active?: boolean }>(({ theme, active = false }) => ({
	position: "relative",
	textDecoration: "none",
	userSelect: "none",

	height: "100%",
	display: "flex",
	flexDirection: "row",
	alignItems: "center",

	cursor: "pointer",
	transition: "all 0.3s ease",

	p: {
		color: theme.palette.common.white,
	},

	"&::before": {
		content: '""',
		bottom: 0, left: 0,
		position: "absolute",
		width: "100%", height: active ? 3 : 0,
		backgroundColor: theme.palette.common.white,
		transition: "all 0.2s ease",
	},

	"&:hover": {
		p: {
			opacity: 0.8,
			color: theme.palette.common.white,
		},

		"&::before": {
			height: 3,
		}
	},

	[theme.breakpoints.down('lg')]: {
		p: {
			opacity: 0.75,
			color: theme.palette.common.white,
		},

		"&:hover": {
			p: {
				opacity: 1,
				color: theme.palette.common.white,
			},
		},
	},
}))

export { SubHeader }